import React, { useState, useEffect } from 'react';
import { Row, Col, Table, Button, Form, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { RestService } from '../utils'; // Assicurati che il path sia corretto
import ConfigHandler from '../config'; // Assicurati che il path sia corretto

// Chiavi suggerite per i "Quick Buttons"
const SUGGESTED_KEYS = ['Riferimento', 'Codice Ordine', 'S-Vlan', 'C-Vlan', 'User Vlan', 'IP Statico', 'Username', 'Password', 'porta ENNI', 'DAC', 'Appuntamento', 'Codice Migrazione', 'Note'];

const MiscInfoEditor = ({ miscInfoData, isAdmin, quoteDetailId, onSaveCallback }) => {

  // Convertiamo l'oggetto key:value in un array di oggetti per gestirne l'ordine e l'editing
  // Struttura interna: [{ id: 123, k: "Key", v: "Value" }]
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    if (miscInfoData) {
      const initialArr = Object.entries(miscInfoData).map(([key, value], index) => ({
        id: Date.now() + index, // ID univoco per React
        k: key, v: value
      }));
      setEntries(initialArr);
    }
  }, [miscInfoData]);

  // --- FUNZIONI DI MANIPOLAZIONE (Solo Admin) ---

  const handleAddKey = (keyName = '') => {
    setEntries([...entries, { id: Date.now(), k: keyName, v: '' }]);
  };

  const handleDelete = (index) => {
    const newEntries = [...entries];
    newEntries.splice(index, 1);
    setEntries(newEntries);
  };

  const handleChange = (index, field, value) => {
    const newEntries = [...entries];
    newEntries[index][field] = value;
    setEntries(newEntries);
  };

  const moveRow = (index, direction) => {
    if (direction === 'up' && index === 0) return;
    if (direction === 'down' && index === entries.length - 1) return;

    const newEntries = [...entries];
    const itemToMove = newEntries[index];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;

    // Swap
    newEntries[index] = newEntries[targetIndex];
    newEntries[targetIndex] = itemToMove;
    setEntries(newEntries);
  };

  const handleSave = () => {
    // Riconvertiamo l'array in oggetto JSON preservando l'ordine (nei limiti di JS)
    const finalObject = {};
    let hasEmptyKeys = false;

    entries.forEach(item => {
      if (item.k.trim() === '') hasEmptyKeys = true;
      else finalObject[item.k] = item.v;
    });

    if (hasEmptyKeys) {
      toast.warn("Attenzione: alcune righe senza chiave sono state ignorate.");
    }

    RestService.post({
      url: ConfigHandler.getConfig().api.baseUrl + ConfigHandler.getConfig().api.path.miscInfo,
      body: {
        quoteDetailId: quoteDetailId,
        miscInfo: finalObject                 // JSON.stringify(finalObject)
      }
    }).then(res => {
      if (res.ok || ~~(res.status / 100) === 2) {
        toast.success("Info aggiornate correttamente");
        if (onSaveCallback) onSaveCallback(finalObject);
      } else {
        toast.error("Errore durante il salvataggio");
      }
    });
  };

  const RenderReadOnlyTable = () => (
    <table className="DataTables ol-details-variant m-1 bg-light">
      <tbody>
        <tr className="dummyTR"><td width="150"></td><td></td></tr>
        {entries.length === 0 && <tr><td colSpan="2" className="text-muted text-center">Preview Box - No extra info.</td></tr>}
        {entries.map((item) => (
          <tr key={item.id}><td className='fw-normal text-nowrap me-2'>{item.k}</td><td className='fw-bold'>{item.v}</td></tr>
        ))}
      </tbody>
    </table>
  );

  if (!isAdmin) {
    if (!entries || entries.length === 0) {
      return null;
    } else {
      return (
        <div className="w-100 p-0 pe-2 pb-2 m-1 bg-light" >
          <div className="m-0 p-1 bg-white border rounded text-right" style={{ pointerEvents: 'none' }}>
            <h6 className="text-danger m-1">Informazioni Tecniche Aggiuntive</h6>
            <RenderReadOnlyTable />
          </div>
        </div>
      );
    }
  } else {
    return (
      <>
        <div className="w-100 p-0 pe-2 pb-2 m-1 bg-light" >
          <div className="m-0 p-1 bg-white border rounded text-right" style={{ pointerEvents: 'none' }}>
            <h6 className="text-danger m-1">Informazioni Tecniche Aggiuntive</h6>
            <RenderReadOnlyTable />
          </div>
        </div>
        <div className="w-100 p-0 pe-2 pb-2 m-1 bg-light" >
          <Card className="m-1 border-info">
            <Card.Header className="bg-white text-danger d-flex justify-content-between align-items-center">
              <span>Informazioni Tecniche Aggiuntive (Editor)</span>
              <Button variant="outline-danger" size="sm" onClick={handleSave}>💾 Salva</Button>
            </Card.Header>
            <Card.Body className='w-100 m-0 p-1'>
              <Row>
                <Col>
                  <div className="m-1">
                    <Button variant="success" size="sm" className="me-1 pb-0 pt-0 ps-1 pe-1 text-white" onClick={() => handleAddKey('')}>Custom</Button>
                    {SUGGESTED_KEYS.map(sKey => {
                      const exists = entries.some(e => e.k.toLowerCase() === sKey.toLowerCase());
                      if (exists) return null;
                      return (
                        <Button key={sKey} variant="info" size="sm" className="me-1 pb-0 pt-0 ps-1 pe-1 text-white" onClick={() => handleAddKey(sKey)}>{sKey}</Button>
                      )
                    })}
                  </div>
                  <div style={{ maxHeight: '1000px', overflowY: 'auto' }}>
                    {entries.map((item, index) => (
                      <div key={item.id} className="d-flex align-items-center me-1 pe-1 pb-1 border rounded bg-light">
                        <div className="d-flex flex-column me-1">
                          <button
                            className="btn btn-link p-0 text-decoration-none"
                            style={{ fontSize: '0.8rem', lineHeight: '10px' }}
                            onClick={() => moveRow(index, 'up')} disabled={index === 0}>▲</button>
                          <button
                            className="btn btn-link p-0 text-decoration-none"
                            style={{ fontSize: '0.8rem', lineHeight: '10px' }}
                            onClick={() => moveRow(index, 'down')} disabled={index === entries.length - 1}>▼</button>
                        </div>
                        <Form.Control type="text" placeholder="inserire chiave" value={item.k} onChange={(e) => handleChange(index, 'k', e.target.value)} className="m-1 form-control-sm" style={{ fontWeight: 'bold', width: '35%' }} />
                        <Form.Control type="text" placeholder="inserire valore" value={item.v} onChange={(e) => handleChange(index, 'v', e.target.value)} className="m-1 form-control-sm" />
                        <Button variant="outline-danger" size="sm" className="fw-bold ms-1 ps-2 pe-2" onClick={() => handleDelete(index)}>✕</Button>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      </>
    );
  }
};

export default MiscInfoEditor;